import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InputSettingsField from './InputSettingsField';
import { StyledFieldWrapper } from './SettingsCommonElements';

const isValid = (value) => value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0);

const MaxRowsSettings = ({ id, maxRows, onChange }) => {
  const [error, setError] = useState(false);

  return (
    <StyledFieldWrapper>
      <InputSettingsField
        id={`${id}-max-rows`}
        type="number"
        label="Max Rows"
        value={maxRows ?? ''}
        error={error}
        description={error ? 'Enter a whole number of zero or more.' : 'Leave empty for unlimited rows.'}
        onChangeText={(value) => setError(!isValid(value))}
        onChange={(fieldId, value) => {
          if (value === '' || Number.isNaN(value)) onChange(null);
          else if (isValid(value)) onChange(Number(value));
        }}
      />
    </StyledFieldWrapper>
  );
};

MaxRowsSettings.propTypes = {
  id: PropTypes.string,
  maxRows: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default MaxRowsSettings;
